module.exports = __webpack_public_path__ + "img/da_left.e95550a3.png";